import { ApexOptions } from 'apexcharts';

export const countOptions: ApexOptions = {
  chart: {
    type: 'bar',
    stacked: true,
    sparkline: {
      enabled: false,
    },
    fontFamily: 'Poppins',
    redrawOnParentResize: true,
    redrawOnWindowResize: true,
    width: '200px',
    toolbar: {
      show: false,
    },
  },
  grid: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      columnWidth: '15%',
    },
  },
  xaxis: {
    type: 'datetime',
    floating: false,
    labels: {
      hideOverlappingLabels: true,
      trim: true,
      datetimeFormatter: {
        day: 'dd/MM',
      },
    },
  },
  yaxis: {
    // title: {
    //   text: 'Quantidade de ordens',
    // },
    labels: {
      align: 'center',
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  tooltip: {
    y: {
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      formatter(val: any): string {
        return `${val}`;
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
};
